<template>
  <div class="missionintro ">
    <b-container>
      <b-row class="content">
        <b-col lg="6" md="12" sm="12">
          <LeftContentmulti id="left" :heading="heading" :paragraphs="paragraphs" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import LeftContentmulti from "../common/leftContent-multipara";
export default {
  name: "Mission",
  props: ["heading", "paragraphs"],
  components: {
    LeftContentmulti
  }
};
</script>
<style scoped>


@media (min-width: 480px) and (max-width: 767px) {
  .missionintro{
     min-height:100vh;
  }
  .content{
  padding: 263px 0px 1px 0px;
  }
}

@media (max-width:480px){
  .missionintro{
     min-height:100vh;
  }
  .content{
 padding: 108px 0px 1px 0px;
  }
}
</style>